// extracted by mini-css-extract-plugin
export var avatar = "_ph-3";
export var avatarContainer = "_ph-2";
export var avatarSpacer = "_ph-5";
export var avatarSpacerContainer = "_ph-4";
export var avatarStackContainer = "_ph-1";
export var bubble = "_ph-0";
export var remainderBubble = "_ph-6";